import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33da3f29"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "export-img-dialog" }
const _hoisted_2 = { class: "thumbnails-view" }
const _hoisted_3 = { class: "configs" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "radio-list" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "radio-list" }
const _hoisted_10 = {
  key: 0,
  class: "row",
  style: {"justify-content":"space-between"}
}
const _hoisted_11 = ["data-range"]
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "title" }
const _hoisted_14 = {
  class: "row",
  style: {"justify-content":"space-between"}
}
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "btns" }

import { computed, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import useExport from '@/hooks/useExport'
import { saveClickData } from "@/api/combo";
import Cookies from 'js-cookie'
import { sendClickData } from "@/utils/common";
import { event } from 'vue-gtag';
import ThumbnailSlide from '@/views/components/ThumbnailSlide/index.vue'
import FullscreenSpin from '@/components/FullscreenSpin.vue'
import {
  Button,
  Tooltip,
  Slider,
  Switch,
  Radio,
} from 'ant-design-vue'
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  __name: 'ExportImage',
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (event: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const { Group: RadioGroup, Button: RadioButton } = Radio
const { t, locale } = useI18n()



const { slides, currentSlide } = storeToRefs(useSlidesStore())

const imageThumbnailsRef = ref<HTMLElement>()
const rangeType = ref<'all' | 'current' | 'custom'>('all')
const range = ref<[number, number]>([1, slides.value.length])
const format = ref<'jpeg' | 'png'>('jpeg')
const quality = ref(1)
const ignoreWebfont = ref(true)

const renderSlides = computed(() => {
  if (rangeType.value === 'all') return slides.value
  if (rangeType.value === 'current') return [currentSlide.value]
  return slides.value.filter((item, index) => {
    const [min, max] = range.value
    return index >= min - 1 && index <= max - 1
  })
})
const { exportImage, exporting } = useExport()
const expImage = () => {
  if (!imageThumbnailsRef.value) return
  // sendClickData type = 17
  event('ppt_download')
  sendClickData(17, 17, '', '')
  exportImage(imageThumbnailsRef.value, format.value, quality.value, ignoreWebfont.value)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "thumbnails",
        ref_key: "imageThumbnailsRef",
        ref: imageThumbnailsRef
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(renderSlides), (slide) => {
          return (_openBlock(), _createBlock(ThumbnailSlide, {
            class: "thumbnail",
            key: slide.id,
            slide: slide,
            size: 1600
          }, null, 8, ["slide"]))
        }), 128))
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t(`editor.exportDialog.exportImage.exportType`)) + "：", 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: _normalizeClass(['radio-item', { 'radio-active': format.value === 'jpeg' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (format.value = 'jpeg'))
          }, " JPEG ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(['radio-item', { 'radio-active': format.value === 'png' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (format.value = 'png'))
          }, " PNG", 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t(`editor.exportDialog.exportScope`)) + "：", 1),
        false
          ? (_openBlock(), _createBlock(_unref(RadioGroup), {
              key: 0,
              class: "config-item",
              value: rangeType.value,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((rangeType).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(RadioButton), {
                  class: "type-btn",
                  style: {"width":"33.33%"},
                  value: "all"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`editor.exportDialog.all`)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(RadioButton), {
                  class: "type-btn",
                  style: {"width":"33.33%"},
                  value: "current"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`editor.exportDialog.thisPage`)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(RadioButton), {
                  class: "type-btn",
                  style: {"width":"33.33%"},
                  value: "custom"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`editor.exportDialog.auto`)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: _normalizeClass(['radio-item', { 'radio-active': rangeType.value === 'all' }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (rangeType.value = 'all'))
          }, _toDisplayString(_ctx.$t(`editor.exportDialog.all`)), 3),
          _createElementVNode("div", {
            class: _normalizeClass(['radio-item', { 'radio-active': rangeType.value === 'current' }]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (rangeType.value = 'current'))
          }, _toDisplayString(_ctx.$t(`editor.exportDialog.thisPage`)), 3),
          _createElementVNode("div", {
            class: _normalizeClass(['radio-item', { 'radio-active': rangeType.value === 'custom' }]),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (rangeType.value = 'custom'))
          }, _toDisplayString(_ctx.$t(`editor.exportDialog.auto`)), 3)
        ])
      ]),
      (rangeType.value === 'custom')
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "title",
              style: {"text-wrap":"nowrap"},
              "data-range": `（${range.value[0]} ~ ${range.value[1]}）`
            }, _toDisplayString(_ctx.$t(`editor.exportDialog.autoScope`)) + "：", 9, _hoisted_11),
            _createVNode(_unref(Slider), {
              class: "config-item",
              range: "",
              min: 1,
              max: _unref(slides).length,
              step: 1,
              value: range.value,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((range).value = $event))
            }, null, 8, ["max", "value"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t(`editor.exportDialog.exportImage.imageQuality`)) + "：", 1),
        _createVNode(_unref(Slider), {
          class: "config-item",
          min: 0,
          max: 1,
          step: 0.1,
          value: quality.value,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((quality).value = $event))
        }, null, 8, ["step", "value"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t(`editor.exportDialog.exportImage.ignoreFont`)) + "：", 1),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_unref(Tooltip), {
            mouseLeaveDelay: 0,
            mouseEnterDelay: 0.5,
            title: _unref(t)(`editor.exportDialog.exportImage.ignoreLineFont`)
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Switch), {
                checked: ignoreWebfont.value,
                "onUpdate:checked": _cache[8] || (_cache[8] = ($event: any) => ((ignoreWebfont).value = $event))
              }, null, 8, ["checked"])
            ]),
            _: 1
          }, 8, ["mouseEnterDelay", "title"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_unref(Button), {
        class: "btn close",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`editor.exportDialog.close`)), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(Button), {
        class: "btn export",
        type: "primary",
        onClick: _cache[10] || (_cache[10] = ($event: any) => (expImage()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`editor.exportDialog.exportImg`)), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(FullscreenSpin, {
      loading: _unref(exporting),
      tip: _unref(t)(`editor.exportDialog.exporting`)
    }, null, 8, ["loading", "tip"])
  ]))
}
}

})